import type { TabProps as MuiTabProps } from '@mui/material/Tab';

import MuiTab from '@mui/material/Tab';
import React from 'react';

import { useTabsContext } from './TabsContext';

export interface TabProps extends Omit<MuiTabProps, 'onClick'> {
  onClick?: (event: React.MouseEvent<HTMLDivElement>, value: any) => void;
  'data-testid'?: string;
}
const Tab = ({
  'data-testid': dataTestId,
  label,
  onClick,
  value,
  ...otherProps
}: TabProps) => {
  const { setCurrentTabValue } = useTabsContext();
  return (
    <MuiTab
      {...otherProps}
      onClick={(e) => {
        setCurrentTabValue(value);
        onClick?.(e, value);
      }}
      data-testid={dataTestId}
      value={value}
      label={label}
    />
  );
};

export default React.memo(Tab);
